// Imports
// ------------
import React from 'react';
import Marquee from 'react-double-marquee';

// Styles
// ------------
import { Jacket, MarqueeContent, Words } from './styles';

// Component
// ------------
const MarqueeHeadline = ({ data, isDark }) => {
    return (
        <Jacket>
            <Marquee direction="left" speed={0.02} childMargin={0}>
                <MarqueeContent>
                    <Words isDark={isDark}>{data}</Words>
                    <Words isDark={isDark}>{data}</Words>
                </MarqueeContent>
            </Marquee>
        </Jacket>
    );
}

export default React.memo(MarqueeHeadline);